/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { verifyToken, getLoggedIdentity } from '~/api/auth';
import { identity } from '~/routes';
import { auth } from '~/api/axios';

const staleTime = 60 * 1000;

export const useIdentityUsePermissionsUseVerifyToken = (options: any = {}) => {
  return useQuery(identity, () => verifyToken().then((res) => res.data), { staleTime, ...options });
};

export const useIdentity = (options: any = {}) => {
  return useQuery(identity, () => getLoggedIdentity().then((res) => res.data), {
    staleTime,
    retry: false,
    onError() { },
    ...options,
  });
};

export const useIsManager = () => {
  // Get current business id.
  const businessId = auth.getProfile();
  // Find identity.
  const { data: identity } = useIdentity();
  // Get all roles this identity has in the current business.
  const identityRoles = businessId && identity?.roles?.[businessId]
  return !!identityRoles?.includes('BUSINESS_MANAGER');
}

export const useIsSelf = (currentEmail?: string) => {
  // Load the identity.
  const { data: identity, isLoading: identityIsLoading } = useIdentity();
  // Self role BUSINESS_ADMINISTRATOR or BUSINESS_MANAGER couldn't be removed.
  const isSelfRole = !identityIsLoading && identity?.emailAddress === currentEmail;
  return isSelfRole;
}
